/* eslint-disable @typescript-eslint/naming-convention */
import {
  Ga4EcommerceBase,
  Ga4EcommercePayment,
  Ga4EcommerceProduct,
  Ga4EventClick,
} from '@models/ga4';
import { ecommerceSet, gaVirtualEvent, virEcommerceSet } from '@utils/ga4';

// GA ECOMMERCE
export const sendGAEcommerce = (
  isNativeAppBoth: boolean,
  _E_step: string,
  _product: Ga4EcommerceProduct, // 상품필드
  _actionList: Ga4EcommercePayment, // 액션필드
  _Dimension: Ga4EcommerceBase, // 기본설정필드
  _Metric: any // 임시타입 추후수정
) => {
  // GA4 DATA SET
  const E_step = _E_step;
  // 상품필드 Set
  const Products: Ga4EcommerceProduct = { ..._product };
  // 액션필드 Set
  const actionList: Ga4EcommercePayment = { ..._actionList };
  // 기본설정필드 Set
  const Dimension: Ga4EcommerceBase = { ..._Dimension };
  Dimension.ep_visit_device = isNativeAppBoth ? 'Mobile App' : 'Mobile Web';

  const Metric = { ..._Metric };

  ecommerceSet(
    isNativeAppBoth,
    E_step,
    [Products],
    actionList,
    Dimension,
    Metric
  );
};

// GA ECOMMERCE
export const sendGAVirEcommerce = (
  isNativeAppBoth: boolean,
  isDesktop: boolean,
  _E_step: string,
  _product: Ga4EcommerceProduct, // 상품필드
  _actionList: Ga4EcommercePayment, // 액션필드
  _Dimension: Ga4EcommerceBase, // 기본설정필드
  _Metric: any // 임시타입 추후수정
) => {
  // GA4 DATA SET
  const E_step = _E_step;
  // 상품필드 Set
  const Products: Ga4EcommerceProduct | undefined = _product
    ? { ..._product }
    : undefined;
  // 액션필드 Set
  const actionList: Ga4EcommercePayment | undefined = _actionList
    ? { ..._actionList }
    : undefined;
  // 기본설정필드 Set
  const Dimension: Ga4EcommerceBase = { ..._Dimension };
  // eslint-disable-next-line no-nested-ternary
  Dimension.ep_visit_device = isNativeAppBoth
    ? 'Mobile App'
    : isDesktop
    ? 'PC Web'
    : 'Mobile Web';

  const Metric = { ..._Metric };
  virEcommerceSet(
    isNativeAppBoth,
    E_step,
    [Products],
    actionList,
    Dimension,
    Metric
  );
};

// GA TEXT EVENT
export const sendGAClickEvent = (
  isNativeAppBoth: boolean,
  isDesktop: boolean,
  value: Ga4EventClick
) => {
  // undefined 값 제거
  const cleanedData = Object.fromEntries(
    Object.entries(value).filter(([_, data]) => data !== undefined)
  );
  // GA4 DATA SET
  const eventObj: Ga4EventClick = { ...cleanedData };
  // eslint-disable-next-line no-nested-ternary
  eventObj.ep_visit_device = isNativeAppBoth
    ? 'Mobile App'
    : isDesktop
    ? 'PC Web'
    : 'Mobile Web';
  gaVirtualEvent(isNativeAppBoth, eventObj);
};
